import styled from "styled-components";
import {
  Button as AntButton,
  Typography,
  Form as AntForm,
  Input as AntInput,
} from 'antd';
import { AuthLogo, AuthHeadingBg } from "@assets/auth";
import lightTheme from '@styles/theme';
import { AuthArrow } from '@assets'

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
  position: relative;
`;

export const Heading = styled.div`
  width: 100%;
  height: 300px;
  background-image: url(${AuthHeadingBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0 0 32px 32px;

  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;
`

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: ${props => props.backKey ? 'end' : 'space-between'};
  align-items: center;
  height: 37px;/* need to add this to be the same height with nav from other auth pages */
  margin: 24px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  margin: 0 0 0 20px;
  width: 36px;
  height: 36px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
`
export const BackIcon = styled(AuthArrow)`
  width: 25px;
  height: 25px;
`;

export const SkipButton = styled(AntButton)`
  display: inline-flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.40);
  margin: 0 20px 0 0;

  color: #F9DF35;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const Logo = styled(AuthLogo)`
  margin: -5px auto 0 auto;
  width: 140px;
  height: 148px;
`
export const Title = styled(Typography.Title)`
  color: #FFF !important;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  margin: 37px 0 0 0;
`

export const ContentContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto 24px;
  padding: 0 16px 0;
`

export const Form = styled(AntForm)`
  margin: 30px 0 0 0;
  width: 100%;
  text-align: center;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    margin-left: 8px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #817774;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  padding-left: 16px;
  height: 56px;
  border-radius: 12px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #342309;
  background: #F2F1F0;


  &::placeholder {
    color: #8E969F;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const TextButton = styled(AntButton)`
  float: right;
  text-align: right;
  color: #DB7802;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: -30px 0 0 0;

  &:hover{
    color: #DB7802 !important;
  }
`

export const ORText = styled.div`
  margin: -20px auto 26px !important;
  text-align: center;
  padding: 5px;
  width: fit-content;
  border-radius: 25px;
  background-color: #F9DF35;

  color: #13100F;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
`

export const LoginButton = styled(AntButton)`
  color: #13100F;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: var(--golden-h, linear-gradient(270deg, #FFE83A 0%, #FF961B 100%)) !important;
  margin: 0px 0 0 0;

  &:hover {
    color: #13100F !important;
    background: var(--golden-h, linear-gradient(270deg, #FFE83A 0%, #FF961B 100%)) !important;
  }
`

export const RegisterButton = styled(AntButton)`
  margin: 0 0 20px;
  border-radius: 12px;
  background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%);

  color: #13100F;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover {
    color: #13100F !important;
    background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%) !important;
  }
`

export const ContinueButton = styled(AntButton)`
  color: ${props => (props.disabled ? '#8E969F' : '#13100F')} !important;
  background: ${props => (props.disabled ? '#DFDFDF' : 'linear-gradient(270deg, #FFE83A 0%, #FF961B 100%)')} !important;
  border: none !important;
  border-radius: 12px !important;
`;

export const PromoWrapper = styled.div`
margin-top: 26px;
display: flex;
flex-direction: column;
gap: 24px;
align-items: center;
justify-content: center;
`;

export const PromoRegisterButton = styled(AntButton)`
  border-radius: 12px;
  background: linear-gradient(269deg, #FFE83A 0.75%, #FF961B 99.27%);

  color: #13100F;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover {
    color: #13100F !important;
    background: linear-gradient(269deg, #FFE83A 0.75%, #FF961B 99.27%) !important;
  }
`

export const PromoORText = styled.div`
  text-align: center;
  padding: 5px;
  width: fit-content;
  border-radius: 25px;
  background-color: #F9DF35;

  color: #13100F;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5; /* 171.429% */
`


export const GoogleLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const TelegramLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;